import { render, staticRenderFns } from "./DictionaryItemList.vue?vue&type=template&id=436279e3&scoped=true"
import script from "./DictionaryItemList.vue?vue&type=script&lang=js"
export * from "./DictionaryItemList.vue?vue&type=script&lang=js"
import style0 from "./DictionaryItemList.vue?vue&type=style&index=0&id=436279e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436279e3",
  null
  
)

export default component.exports